import { store } from "@redux/store";
import { Helpers } from "@utils/helpers";
import { get } from 'lodash';
export class MyInfoUrlRequest {
  public productCode?: string;
  public campaignCode?: string;
  public transaction_id: string;

  constructor(productCode: string, campaignCode?: string | null) {

    if (store.getState().mltcR3Step2.transactionId && window.location.href.includes("mltc")) {
      this.transaction_id = store.getState().mltcR3Step2.transactionId
    } else if (store.getState().sioStep1.transactionId && window.location.href.includes("sio")) {
      this.transaction_id = store.getState().sioStep1.transactionId
    } else if (store.getState().dpiStep1.transactionId && window.location.href.includes("dpi")) {
      this.transaction_id = store.getState().dpiStep1.transactionId
    } else {
      //for shieldStarter and unhandle request  
      this.transaction_id = window.crypto.randomUUID();
    }
    this.productCode = productCode;
    if (campaignCode) this.campaignCode = campaignCode;
  }
}

interface ValueObject { 
  lastupdated?: string,
  source?: string,
  classification?: string, 
  value?: string 
  areacode?: { value: string };
  prefix?: { value: string };
  nbr?: { value: string };
  desc?: string;
  country?: string;
  code?: string;
};

interface AddressObject { 
  country: ValueObject;
  unit: ValueObject;
  street: ValueObject;
  lastupdated: string;
  block: ValueObject;
  source: string;
  classification: string;
  floor: ValueObject;
  type: string;
  building: ValueObject;
  postal: ValueObject;
}

export class MyInfoPersonResponse {
  id?: number;
  uinfin?: ValueObject;
  name?: ValueObject;
  sex?: ValueObject;
  race?: ValueObject;
  nationality?: ValueObject;
  dob?: ValueObject;
  email?: ValueObject;
  mobileno?: ValueObject;
  marital?: ValueObject;
  employment?: ValueObject;
  residentialstatus?: ValueObject;
  regadd?: AddressObject;
  constructor(initial: any) {
    Object.assign(this, { ...initial });
  }

  get address() {
    return {
      postal: this.regadd?.postal?.value,
      floor: this.regadd?.floor?.value,
      unit: this.regadd?.unit?.value,
      street: this.regadd?.street?.value,
      block: this.regadd?.block?.value,
      building: this.regadd?.building?.value
    }
  }

  get personalDetails() {
    const name = Helpers.splitName(this.name?.value || '');
    return {
      ...name,
      dob: this.dob?.value,
      nationality: this.nationality?.code,
      race: this.race?.code,
      emailId: this.email?.value,
      mobileNum: this.mobileno?.nbr?.value,
      nric: this.uinfin?.value,
      gender: this.sex?.code,
      marital: this.marital?.code
    }
  }

  get reviewPersonalDetails() {
    const details = this.personalDetails;
    return [
      { text: 'Full name (as per NRIC)', value: details },
      { text: 'Family name', value: '-' },
      { text: 'Given name', value: '-' },
      { text: 'NRIC/FIN', value: '-' },
      { text: 'Gender', value: '-' },
      { text: 'Nationality', value: '-' },
      { text: 'Date of birth', value: '-' },
      { text: 'Marital status', value: '-' },
      { text: 'Race', value: '-' },
      { text: 'Email', value: 'email' },
      { text: 'Mobile number', value: '000000000' },
      { text: 'Postal code', value: '000000' },
      { text: 'Unit', value: '-' },
      { text: 'Street', value: '-' },
      { text: 'Block', value: '-' },
      { text: 'Building name', value: '' },
    ]
  }
}

export class AddMyInfoRequest {
  id?: number;
  l400Profile: string;
  nric: string;
  fullName: string;
  givenName: string;
  familyName: string;
  salutation: string;
  gender: string;
  race: string;
  nationality: string;
  dob: string;
  email: string;
  mobileNumber: string;
  maritalStatus: string;
  height?: number;
  weight?: number;

  isMailingAddressSame?: string;
  postalCodeRes: string;
  blockRes: string;
  unitRes: string;
  streetNameRes: string;
  buildingNameRes: string;
  postalCodeMail: string;
  blockMail: string;
  unitMail: string;
  streetNameMail: string;
  buildingNameMail: string;

  updateMailingAddFlag?: string;

  occupation: string;
  businessNature: string;
  sourceOfFunds: string;
  sourceOfWealth: string;
  annualIncome: number;

  generalQuestions?: string;
  healthQuestions: string;
  declaration: string;
  customerConsent: string;
  myInfoRespData: string;

  exactDutiesOccupation?: string;
  businessNatureOthers?: string;

  transactionId?: string;

  constructor(initial: any) {
    this.id = get(initial, 'id', 0);
    this.l400Profile = get(initial, 'l400Profile', '');
    this.nric = get(initial, 'uinfin', '');
    this.fullName = get(initial, 'name', '');
    this.gender = get(initial, 'sex', '');
    this.race = get(initial, 'race', '');
    this.nationality = get(initial, 'nationality', '');
    const dob = get(initial, 'dob', { day: undefined, month: undefined, year: undefined });
    this.dob = `${dob.year}-${dob.month}-${dob.day}`;
    this.email = get(initial, 'email', '');
    this.maritalStatus = get(initial, 'marital', '');
    this.mobileNumber = get(initial, 'mobileno', '');
    this.postalCodeRes = get(initial, 'postal', '');
    this.blockRes = get(initial, 'block', '');
    this.unitRes = get(initial, 'unit', '');
    this.streetNameRes = get(initial, 'street', '');
    this.buildingNameRes = get(initial, 'building', '');
    this.givenName = get(initial, 'givenName', '');
    this.familyName = get(initial, 'familyName', '');
    this.salutation = get(initial, 'salutation', '');
    this.isMailingAddressSame = get(initial, 'isMailingAddressSame', '');
    this.postalCodeMail = get(initial, 'postal', '');
    this.blockMail = get(initial, 'block', '');
    this.unitMail = get(initial, 'unit', '');
    this.streetNameMail = get(initial, 'street', '');
    this.buildingNameMail = get(initial, 'building', '');
    this.occupation = get(initial, 'occupation', '');
    this.businessNature = get(initial, 'businessNature', 0);
    this.sourceOfFunds = get(initial, 'sourceOfFunds', '');
    this.sourceOfWealth = get(initial, 'sourceOfWealth', '');
    this.annualIncome = get(initial, 'annualIncome', 0);
    this.healthQuestions = get(initial, 'healthQuestions', '');
    this.declaration = get(initial, 'declaration', '');
    this.customerConsent = get(initial, 'customerConsent', '');
    // this.myInfoRespData = get(initial, 'myInfoRespData', '');
    this.myInfoRespData = '';
    this.height = get(initial, 'height', 0);
    this.weight = get(initial, 'weight', 0);
    this.exactDutiesOccupation = get(initial, 'exactDutiesOccupation', '');
    this.businessNatureOthers = get(initial, 'businessNatureOthers', '');
  }

  patchWithPerson(person: MyInfoPersonResponse) {
    this.nric = person.personalDetails.nric;
    this.fullName = person.personalDetails.fullName;
    this.gender = person.personalDetails.gender;
    this.race = person.personalDetails.race;
    this.nationality = person.personalDetails.nationality;
    this.dob = person.personalDetails.dob;
    this.email = person.personalDetails.emailId;
    this.maritalStatus = person.personalDetails.marital;

    this.postalCodeRes = person.address.postal || '';
    this.blockRes = person.address.block || '';
    this.unitRes = person.address?.floor ? `${person.address?.floor}-${person.address.unit}` : '' + person.address.unit || '';
    this.streetNameRes = person.address.street || '';
    this.buildingNameRes = person.address.building || '';
  }

  patchWithValues(person: any) {
    this.nric = person.nric || this.nric;
    this.fullName = person.fullName || this.fullName;
    this.gender = person.gender || this.gender;
    this.race = person.race || this.race;
    this.nationality = person.nationality || this.nationality;
    this.dob = person.dob || this.dob;
    this.email = person.emailId || this.email;
    this.familyName = person.surname || this.familyName;
    this.givenName = person.givname || this.givenName;
    this.salutation = person.salutation || this.salutation;
    this.mobileNumber = person.mobileNum || this.mobileNumber;
  }

}

export interface IMyInfoQuestionRequest {
  id: number;
  height?: number;
  weight?: number;
  occupation?: string;
  annualIncome?: number;
  smokingStatus?: string;
  exactDutiesOccupation?: string;
  businessNature?: number;
  businessNatureOthers?: string;
  sourceOfFunds?: string; //SAV,Y|MAT_POL,Y|OTH,Sales
  sourceOfWealth?: string; //SAV,Y|MAT_POL,Y|OTH,Sales
  healthQuestions?: string; //"1,Y|2,N|3,Y"
  declaration?: string;
  customerConsent?: string; //SMS,Y|Phone,Y|Mail,N
  transactionId?: string; //Unique ID
}
